<script>
  // The tooltip-wrapped circular icon button used on every job card.
  //
  // This is FileCard/CardButton.svelte, renamed and moved next to the rest of
  // the shared primitives so the two RIC tools carry the same component under
  // the same path. Two changes beyond the move: `last` is gone (spacing is the
  // parent's flex gap now, not a per-button margin), and `href` is supported so
  // a link action does not need a <button> nested in an <a>.
  //
  // Styling note: soft-tinted rather than btn-outline. Five outlined circles in
  // a row on a Solved card read as five warnings.  The colour, icon and ORDER
  // of the buttons are unchanged -- users navigate these by position.
  export let tip;
  export let icon;
  /** primary | secondary | accent | info | success | warning | error */
  export let colour = "primary";
  export let onClick;
  export let href = null;
  export let disabled = false;

  // Full class names, not interpolated fragments: Tailwind's Play CDN scans the
  // DOM, but a class assembled at runtime is one more thing to get wrong.
  const TONE = {
    primary: "text-primary hover:bg-primary hover:text-primary-content",
    secondary: "text-secondary hover:bg-secondary hover:text-secondary-content",
    info: "text-info hover:bg-info hover:text-info-content",
    success: "text-success hover:bg-success hover:text-success-content",
    warning: "text-warning hover:bg-warning hover:text-warning-content",
    error: "text-error hover:bg-error hover:text-error-content",
  };

  $: toneClasses = TONE[colour] ?? TONE.primary;
</script>

<div class="tooltip tooltip-bottom" data-tip={tip}>
  {#if href}
    <a
      {href}
      target="_blank"
      rel="noreferrer"
      class="btn btn-sm btn-circle btn-ghost bg-base-200 {toneClasses}"
      aria-label={tip}
    >
      <i class="fas {icon} text-sm" aria-hidden="true"></i>
    </a>
  {:else}
    <button
      type="button"
      class="btn btn-sm btn-circle btn-ghost bg-base-200 {toneClasses}"
      aria-label={tip}
      {disabled}
      on:click={onClick}
    >
      <i class="fas {icon} text-sm" aria-hidden="true"></i>
    </button>
  {/if}
</div>
